// this hook determines the width of the viewport and based on that returns if it's a mobile width or desktop width

import { useEffect, useState } from "react";

export function useDetectDevice() {
  const [device, setDevice] = useState("desktop");

  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 768) {
        setDevice("mobile");
      }
      else {
        setDevice("desktop");
      }
    };

    // Call handleResize immediately when component mounts
    handleResize();

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return device;
}
